export const searchItemCss = ({ className, overrideCss, isActive, } = {}) => {
    const searchItem = [];
    const searchItemTitle = [];
    const searchItemText = [];
    const searchItemBadge = [];
    if (!overrideCss) {
        searchItem.push('search-item');
        searchItemTitle.push('search-item__title');
        searchItemText.push('search-item__text');
        searchItemBadge.push('search-item__badge');
    }
    if (className) {
        searchItem.push(`${className}`);
        searchItemTitle.push(`${className}__title`);
        searchItemText.push(`${className}__text`);
        searchItemBadge.push(`${className}__badge`);
    }
    if (isActive) {
        if (!overrideCss) {
            searchItem.push('search-item--active');
        }
        if (className) {
            searchItem.push(`${className}--active`);
        }
    }
    return {
        searchItem: searchItem.join(' '),
        searchItemTitle: searchItemTitle.join(' '),
        searchItemText: searchItemText.join(' '),
        searchItemBadge: searchItemBadge.join(' '),
    };
};
//# sourceMappingURL=searchItemCss.js.map